<template>
  <base-section
    id="our-members"
    class="grey lighten-5"
    space="64"
  >
    <span class="trace">People.vue top</span>

    <base-section-heading
      icon=""
      space="0"
      :title="pageTitle"
      class="mb-6"
    />
    <br>
    <v-carousel
      class="mt-n12"
      height="auto"
      light
      continuous
      hide-delimiters="true"
      :show-arrows="true"
    >
      <v-carousel-item
        v-for="(person, i) in people"
        :key="i"
      >
        <!-- {{ i+1 }}  -->
        <!-- {{ i }} {{ people.length }} -->
        <v-container class="fill-height">
          <v-responsive
            class="mx-auto shrink text-center"
            max-width="90%"
            width="700"
          >
            <v-avatar
              v-if="person.avatar.length>0"
              class="mb-2"
              size="144"
            >
              <base-img :src="require(`@/assets/avatars/${person.avatar}`)" />
            </v-avatar>
            <v-avatar
              v-else
              class="mb-2"
              size="144"
            >
              <base-img :src="require(`@/assets/avatars/_blank.png`)" />
            </v-avatar>

            <base-title
              :title="person.name"
              space="0"
            />
            <base-subtitle :title="person.role" />

            <base-body
              :text="myReview(person.review)"
              tag="em"
              class="mb-3 d-block"
            />
            <!--
            <base-body
              :text="person.projects"
              tag="b"
              class="mb-3 d-block"
            />
            -->
            <base-body
              :text="myProjects(person.projects)"
              tag="b"
            />
            <base-body
              v-if="showSocialMedia"
              :html="myFacebook(person.facebook)"
              tag="b"
            />
            <base-body
              v-if="showSocialMedia"
              :html="myLinkedin(person.linkedin)"
              tag="b"
              class="mb-3 d-block"
            />
            <base-body
              v-if="true"
              :html="myEmail(person.email)"
              tag="b"
            />
            <base-body
              :html="myMemberSince(person.memberSince)"
              tag="b"
            />
            <v-container
              v-if="false"
              fluid
            >
              <v-row>
                <v-col
                  v-for="card in cards"
                  :key="card.title"
                  cols="12"
                  sm="12"
                  md="12"
                >
                  <base-info-card
                    align="center"
                    dark
                    v-bind="card"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-responsive>
        </v-container>
      </v-carousel-item>
    </v-carousel>

    <span class="trace">People.vue bottom</span>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionPeople',

    provide: {
      heading: { align: 'center' },
    },
    /*
    {
      review: '"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ratione ipsam consequuntur quo eligendi mollitia veniam facere possimus inventore."',
      name: 'Abou-dan Ahmed',
      // role: 'Truro Energy Committee',
      avatar: '',
      projects: ['Data'],
      // facebook: 'beboyle',
      // linkedin: 'brian-boyle-92789b',
      email: 'ahmed.aboudan@gmail.com',
      memberSince: '2020',
    },
    */

    data: () => ({
      showSocialMedia: false,
      people: [
        {
          name: 'Stuart Alexander',
          // role: 'Truro Energy Committee',
          avatar: '',
          projects: [''],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          email: 'astuart@pacific.net.hk',
          memberSince: '2020',
        },
        {
          review: '"I\'m committed to sustaining Truro\'s beauty, bounty, and harmony with nature by reducing our carbon footprint and promoting organic land use."',
          name: 'Elaine Beilin',
          // role: 'Truro Energy Committee',
          avatar: 'Beilin_Elaine.png',
          projects: ['Communications'],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          // email: 'evbbeilin@gmail.com',
          memberSince: '2020',
        },
        {
          review: 'I\'ve been interested in helping Truro expand its use of renewable sources of energy, so we can contribute to mitigating the global climate change crisis.',
          name: 'Brian Boyle',
          role: 'Truro Energy Committee, Truro Conservation Trust',
          avatar: 'Boyle_Brian.png',
          projects: ['Communications', 'Data', 'All Energy Projects'],
          facebook: 'beboyle',
          linkedin: 'brian-boyle-92789b',
          email: 'beboyle@aol.com',
          memberSince: '2019',
        },
        {
          name: 'Bonnie Brown',
          // role: 'Truro Energy Committee',
          avatar: '',
          projects: [''],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          email: 'topsidecapecod@rocketmail.com',
          memberSince: '2020',
        },
        {
          name: 'Lucy Clark',
          // role: 'Truro Energy Committee',
          avatar: 'Clark_Lucy2020-06-24.png',
          projects: [''],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          email: 'lucyc1217@gmail.com',
          memberSince: '2020',
        },
        {
          name: 'Nathalie Ferrier',
          // role: 'Truro Energy Committee',
          avatar: 'Ferrier_Natalie.png',
          projects: ['Water Quality'],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          email: 'natferrier@gmail.com',
          memberSince: '2020',
        },
        {
          review: '"My goal is to help us be mindful of pollutants that we are putting down our septic systems, that are contaminating the well water we drink on a daily basis, and that may seriously compromise our health. While one person being vigilant is admirable, it takes a whole town\'s participation to really clean up the ever worsening situation of pollutants in our drinking water."',
          name: 'Joanne Hollander',
          role: 'Truro Climate Action Committee',
          avatar: 'Hollander_Joanne.jpg',
          projects: ['Water Quality'],
          email: 'Joanne.hollander@icloud.com',
          memberSince: '2019',
        },
        {
          name: 'Danny Holt',
          // role: 'Truro Energy Committee',
          avatar: 'Holt_Danny2020-06-24.png',
          projects: [''],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          email: 'dhnyny@gmail.com',
          memberSince: '2019',
        },
        /*
        {
          name: 'Joan Holt',
          role: 'Truro Environmental Activist',
          avatar: '',
          projects: [''],
          email: 'capejoanholt@comcast.net',
          memberSince: '2019',
        },
        */
        {
          name: 'Michael Holt',
          role: 'Truro Environmental Activist',
          avatar: 'Holt_Michael2020-07-18.jpg',
          projects: ['Home Energy Assessment'],
          email: 'pianotroubadour@gmail.com',
          memberSince: '2019',

          review0: 'I\'m a musician who cares deeply about community. I summered in Truro all my life and have lived here since 2017. It was here that I fell in love with nature. My first climate activism was in the Transition Towns Movement, which uses sustainability as a rallying point to build community, and uses the power of community to build environmental, social, and economic sustainability. I\'m upset about Truro\'s toxic rift between those pigeonholed as anti-environment and those pigeonholed as anti-development, and I want to do what I can to help heal it. I\'d like to see every element of our town come together in respectful conversation until we reach a common vision of the future Truro we want. My personal vision is of a green, just, localized economy, and a community-oriented way of life.',
          review: 'I\'m a musician who cares deeply about community. I summered in Truro all my life and have lived here since 2017. It was here that I fell in love with nature. My first climate activism was in the Transition Towns Movement, which uses sustainability as a rallying point to build community, and uses the power of community to build environmental, social, and economic sustainability. I\'m upset about Truro\'s toxic rift between those pigeonholed as anti-environment and those pigeonholed as anti-development. Let\'s talk, and start to heal the rift.',
        },
        {
          // review: '"Carrying on the work started by my father, Bob Holt."',
          name: 'Timothy Horn',
          // role: 'Truro Environmental Activist',
          avatar: '',
          projects: ['Fire Prevention'],
          email: 'timothhorn@hotmail.com',
          memberSince: '2020',
        },

        {
          review: '""',
          name: 'Deidre Huang',
          // role: 'Truro Energy Committee',
          avatar: '',
          projects: [''],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          email: 'dedehuang@me.com',
          memberSince: '2020',
        },
        {
          name: 'Cecily Miller',
          // role: 'Truro Energy Committee',
          avatar: '',
          projects: [''],
          // facebook: 'beboyle',
          // linkedin: 'brian-boyle-92789b',
          email: 'cecilymiller.boston@gmail.com',
          memberSince: '2020',
        },
        {
          review: 'John was instrumental in starting Truro to address the issues of climate change. He passed away in April 2020 after battling cancer.  His spirit is dearly missed.',
          name: 'John Hopkins - R.I.P.',
          role: 'Truro Environmental Activist',
          keyName: 'Hopkins_John',
          avatar: 'Hopkins_John.jpg',
          memberSince: '2019',
        },
        /*
        {
          review: '"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam aspernatur, sint recusandae cum temporibus quos saepe repellendus consectetur et reprehenderit. Ratione ipsam consequuntur quo eligendi mollitia veniam facere possimus inventore."',
          name: 'HENRY LUSIO',
          role: 'DIRECTOR OF EXAMPLE LTD',
        },
        {
          review: '"Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam aspernatur, sint recusandae cum temporibus quos saepe repellendus consectetur et reprehenderit. Ratione ipsam consequuntur quo eligendi mollitia veniam facere possimus inventore."',
          name: 'HENRY LUSIO',
          role: 'DIRECTOR OF EXAMPLE LTD',
        },
        */
      ],

      cards: [
        {
          icon: '',
          title: 'Truro Committees',
          text: '',
          html: '<a href="https://provincetown.wickedlocal.com/news/20200510/truro-vietnam-vet-activist-john-hopkins-dies-in-costa-rica" target="_page2">Truro Vietnam vet, climate activist John Hopkins dies in Costa Rica</a><br><a href="https://provincetownindependent.org/news/2020/04/30/john-hopkins-dies-in-costa-rica/" target="_page2">John Hopkins Dies in Costa Rica, April 23, 2020</a>',
        },
      ],

    }),

    /*     */
    computed: {
      pageTitle: function () {
        return 'Our ' + String(this.people.length - 1) + ' Members (so far)'
      },
    },

    methods: {
      myProjects: function (projects) {
        if (projects === undefined) return ''
        if (projects.length > 1) return 'C.A.T. PROJECTS: ' + projects.join(', ')
        if (projects.length === 0) return 'C.A.T. PROJECTS: none'
        if (projects[0] === '') return 'C.A.T. PROJECTS: none'
        return 'C.A.T. PROJECT: ' + projects[0]
      },
      myFacebook: function (facebook) {
        if (facebook === undefined) return ''
        const url = 'https://www.facebook.com/' + facebook
        return 'FACEBOOK: <a href=' + url + ' target="_blank">' + url + '</a>'
      },
      myLinkedin: function (linkedin) {
        if (linkedin === undefined) return ''
        const url = 'https://www.linkedin.com/in/' + linkedin
        return 'LINKEDIN: <a href=' + url + " target='_blank'>" + url + '</a>'
      },
      myEmail: function (email) {
        if (email === undefined) return ''
        const url = 'mailto:' + email
        return 'EMAIL: <a href=' + url + " target='_blank'>" + email + '</a>'
      },
      myReview: function (review) {
        if (review === undefined) return ''
        return review
      },
      myMemberSince: function (d) {
        if (d === undefined) return ''
        return 'MEMBER SINCE: ' + d
      },
    },

  }

</script>

<style lang="sass">
  #our-members
    .v-carousel__controls
      background: transparent

    .base-body
      line-height: 2
</style>
